import axios from './axiosCore';

export function getUserTests(guid: string) {
  return axios.get(`/api/v2/users/${guid}/reliability_tests`);
}
